<div class="bc-page-header-content-right-icons">
    <span class="star-icon" [class.filled]="filled" (click)="toggleFilled()" title="Marcar o Desmarcar contrato como favorito">&#9733;</span>
</div>
